module.exports = {"pagination":{"ListDeadLetterSourceQueues":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"queueUrls"},"ListQueues":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"QueueUrls"}}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/sqs-2012-11-05.paginators.json
// module id = 742
// module chunks = 2